var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"video-wrapper lightbox-video-wrapper"},[_c('iframe',{staticClass:"Video",attrs:{"src":_vm.src,"frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})]),_vm._v(" "),_c('p',{staticClass:"video-caption"})])
}
var staticRenderFns = []

export { render, staticRenderFns }